<script>
import {mapState} from 'vuex'
import Chief from './Chief'
import MoralPersonSearch from '../moralPersons/MoralPersonSearch'
import PhysicalPersonSearch from '../physicalPersons/PhysicalPersonSearch'
import PhysicalPersonCreate from '../physicalPersons/PhysicalPersonCreate'
import PhysicalPersonEdit from '../physicalPersons/PhysicalPersonEdit'
import MoralPersonCreate from '../moralPersons/MoralPersonCreate'
import MoralPersonEdit from '../moralPersons/MoralPersonEdit'
import PappersChief from './PappersChief'
import loading from '../../../../common/components/loading'

export default {
    name: 'Chiefs',

    components: {
        PappersChief,
        MoralPersonSearch,
        MoralPersonCreate,
        MoralPersonEdit,
        PhysicalPersonSearch,
        PhysicalPersonCreate,
        PhysicalPersonEdit,
        Chief,
    },

    props: {
        clientData: {},
        fullVue: null,
    },

    data() {
        return {
            loading: false,
        }
    },

    created() {
        this.$store.commit('legalVM/SET_CLIENT', this.clientData)
        this.$store.commit('legalVM/RESET_STATUS')
    },

    methods: {
        update() {
            if (this.fullVue) {
                this.$emit('update-company')
            } else {
                location.reload()
            }
        },

        showSearch(type) {
            this.$store.commit('legalVM/SET_PERSON_TYPE', type)
            this.$store.commit('legalVM/SET_LINK_TYPE', 'chiefs')
            this.$store.commit('legalVM/SHOW_SEARCH')
        },

        showEdit() {
            this.$store.commit('legalVM/SET_LINK_TYPE', 'chiefs')
            this.$store.commit('legalVM/SHOW_EDIT')
        },

        resetKey() {
            this.key = Date.now()
        },

        async updatePappers() {
            console.log('pappers update')
            this.loading = true
            this.pappers = {}
            try {
                await axios.put(
                    `/moralPersons/${this.client.main_moral_person_id}/pappers`
                )
                await this.$store.dispatch(
                    'legalVM/getClientData',
                    this.client.id
                )
                this.loading = false
                this.resetKey()
            } catch (error) {
                console.error(error)
            }
        },
    },

    computed: {
        ...mapState({
            client: (state) => state.legalVM.client,
            editing: (state) => state.legalVM.editing,
            searching: (state) => state.legalVM.searching,
            creating: (state) => state.legalVM.creating,
            personType: (state) => state.legalVM.personType,
            linkType: (state) => state.legalVM.linkType,
        }),

        chiefs() {
            return this.client.chiefs === null || this.client.chiefs === undefined
                ? null
                : this.client.chiefs.data
        },

        noChief() {
            return this.chiefs === null || (this.chiefs.length === 0 && !this.searching && !this.editing)
        },

        pappersChiefs() {
            return this.client.pappers_data.chiefs
        },

        noPappersChief() {
            return (
                this.pappersChiefs.length === 0 &&
                !this.searching &&
                !this.editing
            )
        },
    },
}
</script>
<template>
    <div>
        <div v-if="!creating && !editing">
            <h4>Liste des dirigeant·e·s</h4>
<!--            <p v-if="!noChief">type: {{ linkType }}</p>-->
            <b-alert :show="noChief" variant="primary">
                Aucun·e dirigeant·e n'a été saisi·e pour cette société
            </b-alert>

            <div>
                <chief
                    v-for="chief in chiefs"
                    :key="'chief' + chief.id"
                    :item="chief"
                    :can-edit="true"
                    @chief-is-deleted="update"
                />
            </div>

            <b-button
                v-if="!searching && !editing && !creating"
                variant="primary"
                size="sm"
                @click="showSearch('physical')"
            >
                <i class="fas fa-plus fa-fw"></i> Ajouter une personne physique
            </b-button>
            <b-button
                v-if="!searching && !editing && !creating"
                variant="primary"
                size="sm"
                @click="showSearch('moral')"
            >
                <i class="fas fa-plus fa-fw"></i> Ajouter une personne morale
            </b-button>
        </div>

        <div v-if="personType === 'moral' && linkType==='chiefs'">
            <moral-person-search v-if="searching"/>
            <moral-person-create v-if="creating"/>
            <moral-person-edit v-if="editing"/>
        </div>

        <div v-if="personType === 'physical' && linkType==='chiefs'">
            <physical-person-search v-if="searching"/>
            <physical-person-create v-if="creating" :person-type="'chiefs'"/>
            <physical-person-edit v-if="editing"/>
        </div>
    </div>
</template>


<style scoped></style>
